export enum DrawerState {
  closed = 0,
  preview,
  open,
}
